// AI Media API Service - Image & Video Generation
import { getUserAuthToken } from '../utils/authToken';

const AUTH0_TOKEN_URL = 'https://dev-z28vfnikmpungvpz.us.auth0.com/oauth/token';
const API_BASE_URL = 'https://annadaneshwar-ai.azurewebsites.net/api';

const AUTH_CONFIG = {
  client_id: '07KrPdn3WkpfLGBnxaTq967P9dILfk9I',
  client_secret: 'x5NQTGdG9LutinYjwjDfDqUidMSLY6ndh3SQNfRfCizflZwX3xXwMXPwEoP2Z1GE',
  audience: 'https://annadaneshwar-ai.azurewebsites.net/',
  grant_type: 'client_credentials'
};

// Token cache
let cachedToken = null;
let tokenExpiry = null;

/**
 * Get Auth0 access token (cached)
 */
export const getAccessToken = async () => {
  // Return cached token if still valid
  if (cachedToken && tokenExpiry && Date.now() < tokenExpiry) {
    return cachedToken;
  }

  try {
    const response = await fetch(AUTH0_TOKEN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(AUTH_CONFIG)
    });

    if (!response.ok) {
      throw new Error(`Failed to get access token: ${response.status}`);
    }

    const data = await response.json();
    cachedToken = data.access_token;
    // Set expiry to 5 minutes before actual expiry
    tokenExpiry = Date.now() + ((data.expires_in - 300) * 1000);

    return cachedToken;
  } catch (error) {
    console.error('Error getting access token:', error);
    throw error;
  }
};

/**
 * Generate image from text prompt
 * @param {string} prompt - Text description of the image to generate
 * @returns {Blob} - Image blob
 */
export const generateImage = async (prompt) => {
  try {
    const userToken = getUserAuthToken();
    const token = userToken?.token || await getAccessToken();

    const response = await fetch(`${API_BASE_URL}/image/generate`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'omit',
      headers: {
        'Accept': 'application/octet-stream',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Origin': window.location.origin,
      },
      body: JSON.stringify(prompt)
    });

    if (!response.ok) {
      const errorText = await response.text();
      if (response.status === 403) {
        throw new Error(`CORS error (403): Check Azure API Management CORS settings. ${errorText}`);
      }
      throw new Error(`Image generation failed: ${response.status} - ${errorText}`);
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating image:', error);
    throw error;
  }
};

/**
 * Download blob as file
 * @param {Blob} blob - File blob
 * @param {string} filename - Desired filename
 */
export const downloadBlob = (blob, filename = 'generated-image.png') => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Create preview URL from blob
 * @param {Blob} blob - Image blob
 * @returns {string} - Object URL for preview
 */
export const createPreviewUrl = (blob) => {
  return window.URL.createObjectURL(blob);
};

/**
 * Generate video from text prompt (placeholder for future implementation)
 * @param {string} prompt - Text description of the video to generate
 * @returns {Blob} - Video blob
 */
export const generateVideo = async (prompt) => {
  // TODO: Implement when video generation API is available
  throw new Error('Video generation not yet implemented');
};

/**
 * Edit image (placeholder for future implementation)
 * @param {File} image - Original image file
 * @param {string} prompt - Edit instructions
 * @returns {Blob} - Edited image blob
 */
export const editImage = async (image, prompt) => {
  // TODO: Implement when image editing API is available
  throw new Error('Image editing not yet implemented');
};
